import { useState } from 'react';
import usePreservedCallback from './usePreservedCallback';

export default function useLoading(): [
  boolean,
  <T>(promise: Promise<T>) => Promise<T>,
] {
  const [loading, setLoading] = useState(false);

  const start = usePreservedCallback(async <T>(promise: Promise<T>) => {
    try {
      setLoading(true);
      return await promise;
    } finally {
      setLoading(false);
    }
  });

  return [loading, start];
}
